// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scroll-container21 {
  overflow-x: auto;
  white-space: nowrap;
  width: 100%;
  height: auto;
}


.resume-container-21 {
  
  display: flex;
  flex-direction: column;
  padding: 20px;
  width: 1000px !important;
  justify-content: center;  
  align-items: flex-end !important;    
  margin: 0;    

  height: auto;
  
}
.resume21 {
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  max-width: 800px;
  border: 1px solid #ddd;
  border-radius: 5px;
  height: auto; 
  box-shadow: -1px 2px 24px rgba(0, 0, 0, 0.1);
}
.row-container{
  display: flex;
  flex-wrap: wrap;
  position: relative;
  /* min-height: 1000px; */
  height: 100%;
  
}
.resumee{
  margin-top: 10px;
  z-index: -1;
  position: absolute;
  width: 800px;

  top: 0;
  background-color: #542344;
  height: 200px;

 
}
.name21 {
  display: flex;
  align-items: end;
  justify-content: start;
  padding-left: 330px;
  font-size: 2.5em;
  margin-top: 20px;
  font-weight: bold;
  color: white;
  text-transform: uppercase;
}
.tc21{
  display: flex;
  justify-content: start;
  padding-left: 330px;
  font-weight: 330;
  color: white;
  text-transform: capitalize;
}

.resume-left21 {
  background-color: #f2eff4;
  color: #ecf0f1;
  /* display: flex;
  flex-direction: column;
   */
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-evenly; 
  padding: 20px;
  text-align: left;
  position: relative;
  /* top: 0; */
  margin-left: 10px;
  width: 280px;

  
  
} 
.resume-right21 {
  background-color: white;
  color: #333;
  position: relative;
  margin-top: 227px; 
  text-align: left;
  width: 480px;
  text-wrap: wrap;
  padding-left: 30px;
 
    
}




.resume-section21 {
  margin-bottom: 18px;
}

.resume-section21 ul li {
  margin-bottom: 8px;
  align-items: center;
  font-size: 14px;
  color: #333;
  text-wrap: wrap;
  text-align: left;
  word-break: break-word;
  
  justify-content: left;
}
.section-title-left21{
  font-size: 20px;
  /* margin-bottom: 0.2px; */
  text-transform: uppercase;
  font-weight: 700;
  color: #542344;
  letter-spacing: 2px;
  line-height: 10px;
}
.section-title-right21 {
 
  margin-bottom: 8px !important;
  color: #542344;
  margin-top: 0px !important;
  text-transform: uppercase;
  font-size: 20px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-weight: bold;
  line-height: 4px;
  letter-spacing: 2px;
}


.icon21{
  height: 14px;
  width: 19px;
  margin-right: 3px;
  color: #542344;
  margin-top: 5px;
}
.contact21{
  font-size: 14px;
  letter-spacing: 1px;
  
  
}
.d-flex21{
  color: #542344;
  font-size: 16px;

}


.bold-title8 {
  font-weight: bold;
}
.bold8{
  font-weight: 700;
  font-size: 14px;
}
.button-container1 {
  width: 77%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 10px 0; 
  padding: 0 0rem 0 11rem;
}
.bk8 {
  justify-self: start;
}

.db21 {
  justify-self: end;
}
.db21{

  background-color:#474559 !important;
  color: #fff !important;
  border: 2px solid white;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-weight: bold;
  font-size: large;
  margin-top: 8px;
  margin-left: 18rem;
  text-wrap: nowrap;

}
.bk8{

  background-color:#474559 !important;
  color: #fff !important;
  border: 2px solid white;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-weight: bold;
  font-size: large;
  margin-top: 8px;
  display: block;
}


@media (max-width: 768px) {
.db21{
  padding-top: 0px !important;
  margin-left: 0px;
}
.button-container1{
  padding: 0px;
  margin-left: 0px;
  align-items: flex-start;
}

@media (min-width: 768px) and (max-width: 1024px) {
  .db21{
    padding-top: 0px !important;
    margin-left: 264px;
  }
  .button-container1{
    padding: 0px;
    margin-left: 0px;
    align-items: flex-start;
  }
}



.resume-container-8 {
  align-items:flex-start !important;
  
}
}



.tc8{
  display: flex;
  justify-content: space-evenly;
  margin-left: 35px;
  font-weight: 330;
  color: white;
  text-transform: capitalize;
}
.tc8::first-letter {
  text-transform: uppercase;
}
.jobtitle {
  color: #542344;
  /* color: #333333; */
  display: inline-block; /* or display: block; */
  
}
.jobtitle::first-letter{
  text-transform: uppercase !important;
}



          


.p8{
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  color: #333333;
  /* word-wrap: break-word; */
  text-align: justify;
  word-spacing: 0.5px;
  line-height: 15px;
}
.bold8{
  font-weight: bold;
}
/* .resume-section8 {
  margin-bottom: 14px;
} */


.section-title1 {
  font-size: 19px;
  margin-bottom: 20px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-weight: bold;
  color: rgb(82, 78, 78);
  text-transform: uppercase;
  margin-top: 28px;
}


.experience-item8, .education-item8 {
  margin-bottom: 18px;
}

.resume-section21 ul {
  list-style: none;

  padding: 0;
  /* margin: 0; */
}



/* .resume-section8 ul li span {
  margin-left: 14px;
} */

 
.subheading21{
  color: #542344;
  margin-bottom: 2px;
  font-size: 16px;
  

}
/* .subheading9{
  color: #542344;
  /* margin-bottom: 0;
  font-size: 12px; */
  /* margin-bottom: 2px;
  font-size: 16px;
} */ */
.p1 {
  /* font-weight: bold; */
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-size: 16px;
  /* margin: 4px 0; */
  text-align: justify;
  text-wrap: wrap;
  line-height: 22px; ;
}
/* .p11 {
  font-weight: bold;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-size: 14px;
  margin: 4px 0;

} */

.p11 {
  font-weight: bold;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-size: 14px;
  margin: 4px 0;
  display: flex;
}

.title1{
  text-wrap: nowrap;
  color: #542344;
}
.span21 {
  font-size: 16px;
  font-weight: normal;
  line-height: 20px;
  color: #333333;
  text-wrap: wrap;
  text-align: justify;
}

.profile-image21 img {
  width: 160px;
  height: 160px;
  border-radius: 50%;
  border: 2px solid rgb(126, 155, 189);
  margin: 10px auto;
  justify-content: center !important;
  align-items: center !important;
  object-fit: cover;
  display: block;

}
.experience-item8, .education-item8 {
  position: relative;
  padding-left: 28px;
  border-left: 2px solid #0bb8f4;
  margin-bottom: 20px;
}

.experience-item8::before, .education-item8::before {
  content: "";
  /* position: absolute;
  top: 0; */
  /* left: -4px; */
  width: 6px;
  height: 6px;
  border-radius: 80%;
  border: 2px solid #0bb8f4 ;
}



@media (max-width: 768px) {
  .experience-item8, .education-item8 {
    padding-left: 20px;
    border-left-width: 1px;
  }

  .experience-item8::before, .education-item8::before {
    width: 6px;
    height: 6px;
    left: -4px;
  }
}
@media (max-width: 768px) {

  .resume-left8 {
    padding: 18px;

  }

  .resume-right21 {
    padding: 18px;
  }

  .section-title-right21 {
    font-size: 20px;
  }
  .section-title1 {
    font-size: 20px;
  }

  .experience-item8 h3, .education-item8 h3 {
    font-size: 16px;
  }

  .experience-item8 h4, .education-item8 h4 {
    font-size: 16px;
  }
}

@media (max-width: 480px) {


  .resume-section21 {
    margin-bottom: 18px;
  }

  .experience-item8, .education-item8 {
    margin-bottom: 10px;
  }

  .experience-item8 h3, .education-item8 h3 {
    font-size: 16px;
  }

  .experience-item8 h4, .education-item8 h4 {
    font-size: 16px;
  }

  .resume-section21 ul li {
    font-size: 14px;
  }
}


/* .resume-section8.hr8 {
  
  border: 8px solid #542344;
   margin-top: 20px ; 
} */

.hr7 {
  width: 80%;
  margin-top: 4px;
  margin-bottom: 10px;
  border-top: 0.1rem solid  #542344;
}
.hr9 {
  width: 100%;

  margin-bottom: 8px;
  border-top: 0.1rem solid  #542344;
}

.footer8 {
  padding: 3px 0;
  margin-top: 20px;
  border-top: 1px solid #e9ecef;
}

.footer-text8 {
  font-size: 16px;
  color: #6c787d; 
  text-align: end;
  margin-right: 18px;
  margin-bottom: 2px;
}

.footer-link8 {
  color: #007bff; 
  text-decoration: none;
}



`, "",{"version":3,"sources":["webpack://./src/components/Resume/Template/UseTemp21.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;;AAGA;;EAEE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,wBAAwB;EACxB,uBAAuB;EACvB,gCAAgC;EAChC,SAAS;;EAET,YAAY;;AAEd;AACA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,4CAA4C;AAC9C;AACA;EACE,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,wBAAwB;EACxB,YAAY;;AAEd;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,YAAY;;EAEZ,MAAM;EACN,yBAAyB;EACzB,aAAa;;;AAGf;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd;;IAEE;EACF,eAAe;EACf,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,YAAY;;;;AAId;AACA;EACE,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;;;AAGpB;;;;;AAKA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,sBAAsB;;EAEtB,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,0BAA0B;EAC1B,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;AACA;;EAEE,6BAA6B;EAC7B,cAAc;EACd,0BAA0B;EAC1B,yBAAyB;EACzB,eAAe;EACf,4DAA4D;EAC5D,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;;AAGA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;EACf,mBAAmB;;;AAGrB;AACA;EACE,cAAc;EACd,eAAe;;AAEjB;;;AAGA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,UAAU;EACV,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;AACA;;EAEE,mCAAmC;EACnC,sBAAsB;EACtB,uBAAuB;EACvB,4DAA4D;EAC5D,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;;AAEnB;AACA;;EAEE,mCAAmC;EACnC,sBAAsB;EACtB,uBAAuB;EACvB,4DAA4D;EAC5D,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;;AAGA;AACA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE;IACE,2BAA2B;IAC3B,kBAAkB;EACpB;EACA;IACE,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;EACzB;AACF;;;;AAIA;EACE,iCAAiC;;AAEnC;AACA;;;;AAIA;EACE,aAAa;EACb,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,0BAA0B;AAC5B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,oBAAoB;EACpB,qBAAqB,EAAE,uBAAuB;;AAEhD;AACA;EACE,oCAAoC;AACtC;;;;;;;AAOA;EACE,qCAAqC;EACrC,eAAe;EACf,cAAc;EACd,2BAA2B;EAC3B,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;;GAEG;;;AAGH;EACE,eAAe;EACf,mBAAmB;EACnB,4DAA4D;EAC5D,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;AAClB;;;AAGA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;;EAEhB,UAAU;EACV,eAAe;AACjB;;;;AAIA;;GAEG;;;AAGH;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;;;AAGjB;AACA;;;oBAGoB;EAClB;;GAEC,EAAE;;EAEH,uBAAuB;EACvB,4DAA4D;EAC5D,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;AACA;;;;;;GAMG;;AAEH;EACE,iBAAiB;EACjB,4DAA4D;EAC5D,eAAe;EACf,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,oCAAoC;EACpC,iBAAiB;EACjB,kCAAkC;EAClC,8BAA8B;EAC9B,iBAAiB;EACjB,cAAc;;AAEhB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX;WACS;EACT,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,0BAA0B;AAC5B;;;;AAIA;EACE;IACE,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,WAAW;IACX,UAAU;EACZ;AACF;AACA;;EAEE;IACE,aAAa;;EAEf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;;;EAGE;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;;AAGA;;;;GAIG;;AAEH;EACE,UAAU;EACV,eAAe;EACf,mBAAmB;EACnB,iCAAiC;AACnC;AACA;EACE,WAAW;;EAEX,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB","sourcesContent":[".scroll-container21 {\r\n  overflow-x: auto;\r\n  white-space: nowrap;\r\n  width: 100%;\r\n  height: auto;\r\n}\r\n\r\n\r\n.resume-container-21 {\r\n  \r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 20px;\r\n  width: 1000px !important;\r\n  justify-content: center;  \r\n  align-items: flex-end !important;    \r\n  margin: 0;    \r\n\r\n  height: auto;\r\n  \r\n}\r\n.resume21 {\r\n  height: 100%;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  width: 100%;\r\n  max-width: 800px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 5px;\r\n  height: auto; \r\n  box-shadow: -1px 2px 24px rgba(0, 0, 0, 0.1);\r\n}\r\n.row-container{\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  position: relative;\r\n  /* min-height: 1000px; */\r\n  height: 100%;\r\n  \r\n}\r\n.resumee{\r\n  margin-top: 10px;\r\n  z-index: -1;\r\n  position: absolute;\r\n  width: 800px;\r\n\r\n  top: 0;\r\n  background-color: #542344;\r\n  height: 200px;\r\n\r\n \r\n}\r\n.name21 {\r\n  display: flex;\r\n  align-items: end;\r\n  justify-content: start;\r\n  padding-left: 330px;\r\n  font-size: 2.5em;\r\n  margin-top: 20px;\r\n  font-weight: bold;\r\n  color: white;\r\n  text-transform: uppercase;\r\n}\r\n.tc21{\r\n  display: flex;\r\n  justify-content: start;\r\n  padding-left: 330px;\r\n  font-weight: 330;\r\n  color: white;\r\n  text-transform: capitalize;\r\n}\r\n\r\n.resume-left21 {\r\n  background-color: #f2eff4;\r\n  color: #ecf0f1;\r\n  /* display: flex;\r\n  flex-direction: column;\r\n   */\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  justify-content: space-evenly; \r\n  padding: 20px;\r\n  text-align: left;\r\n  position: relative;\r\n  /* top: 0; */\r\n  margin-left: 10px;\r\n  width: 280px;\r\n\r\n  \r\n  \r\n} \r\n.resume-right21 {\r\n  background-color: white;\r\n  color: #333;\r\n  position: relative;\r\n  margin-top: 227px; \r\n  text-align: left;\r\n  width: 480px;\r\n  text-wrap: wrap;\r\n  padding-left: 30px;\r\n \r\n    \r\n}\r\n\r\n\r\n\r\n\r\n.resume-section21 {\r\n  margin-bottom: 18px;\r\n}\r\n\r\n.resume-section21 ul li {\r\n  margin-bottom: 8px;\r\n  align-items: center;\r\n  font-size: 14px;\r\n  color: #333;\r\n  text-wrap: wrap;\r\n  text-align: left;\r\n  word-break: break-word;\r\n  \r\n  justify-content: left;\r\n}\r\n.section-title-left21{\r\n  font-size: 20px;\r\n  /* margin-bottom: 0.2px; */\r\n  text-transform: uppercase;\r\n  font-weight: 700;\r\n  color: #542344;\r\n  letter-spacing: 2px;\r\n  line-height: 10px;\r\n}\r\n.section-title-right21 {\r\n \r\n  margin-bottom: 8px !important;\r\n  color: #542344;\r\n  margin-top: 0px !important;\r\n  text-transform: uppercase;\r\n  font-size: 20px;\r\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n  font-weight: bold;\r\n  line-height: 4px;\r\n  letter-spacing: 2px;\r\n}\r\n\r\n\r\n.icon21{\r\n  height: 14px;\r\n  width: 19px;\r\n  margin-right: 3px;\r\n  color: #542344;\r\n  margin-top: 5px;\r\n}\r\n.contact21{\r\n  font-size: 14px;\r\n  letter-spacing: 1px;\r\n  \r\n  \r\n}\r\n.d-flex21{\r\n  color: #542344;\r\n  font-size: 16px;\r\n\r\n}\r\n\r\n\r\n.bold-title8 {\r\n  font-weight: bold;\r\n}\r\n.bold8{\r\n  font-weight: 700;\r\n  font-size: 14px;\r\n}\r\n.button-container1 {\r\n  width: 77%;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin: 10px 0; \r\n  padding: 0 0rem 0 11rem;\r\n}\r\n.bk8 {\r\n  justify-self: start;\r\n}\r\n\r\n.db21 {\r\n  justify-self: end;\r\n}\r\n.db21{\r\n\r\n  background-color:#474559 !important;\r\n  color: #fff !important;\r\n  border: 2px solid white;\r\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n  font-weight: bold;\r\n  font-size: large;\r\n  margin-top: 8px;\r\n  margin-left: 18rem;\r\n  text-wrap: nowrap;\r\n\r\n}\r\n.bk8{\r\n\r\n  background-color:#474559 !important;\r\n  color: #fff !important;\r\n  border: 2px solid white;\r\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n  font-weight: bold;\r\n  font-size: large;\r\n  margin-top: 8px;\r\n  display: block;\r\n}\r\n\r\n\r\n@media (max-width: 768px) {\r\n.db21{\r\n  padding-top: 0px !important;\r\n  margin-left: 0px;\r\n}\r\n.button-container1{\r\n  padding: 0px;\r\n  margin-left: 0px;\r\n  align-items: flex-start;\r\n}\r\n\r\n@media (min-width: 768px) and (max-width: 1024px) {\r\n  .db21{\r\n    padding-top: 0px !important;\r\n    margin-left: 264px;\r\n  }\r\n  .button-container1{\r\n    padding: 0px;\r\n    margin-left: 0px;\r\n    align-items: flex-start;\r\n  }\r\n}\r\n\r\n\r\n\r\n.resume-container-8 {\r\n  align-items:flex-start !important;\r\n  \r\n}\r\n}\r\n\r\n\r\n\r\n.tc8{\r\n  display: flex;\r\n  justify-content: space-evenly;\r\n  margin-left: 35px;\r\n  font-weight: 330;\r\n  color: white;\r\n  text-transform: capitalize;\r\n}\r\n.tc8::first-letter {\r\n  text-transform: uppercase;\r\n}\r\n.jobtitle {\r\n  color: #542344;\r\n  /* color: #333333; */\r\n  display: inline-block; /* or display: block; */\r\n  \r\n}\r\n.jobtitle::first-letter{\r\n  text-transform: uppercase !important;\r\n}\r\n\r\n\r\n\r\n          \r\n\r\n\r\n.p8{\r\n  font-family: 'Montserrat', sans-serif;\r\n  font-size: 14px;\r\n  color: #333333;\r\n  /* word-wrap: break-word; */\r\n  text-align: justify;\r\n  word-spacing: 0.5px;\r\n  line-height: 15px;\r\n}\r\n.bold8{\r\n  font-weight: bold;\r\n}\r\n/* .resume-section8 {\r\n  margin-bottom: 14px;\r\n} */\r\n\r\n\r\n.section-title1 {\r\n  font-size: 19px;\r\n  margin-bottom: 20px;\r\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n  font-weight: bold;\r\n  color: rgb(82, 78, 78);\r\n  text-transform: uppercase;\r\n  margin-top: 28px;\r\n}\r\n\r\n\r\n.experience-item8, .education-item8 {\r\n  margin-bottom: 18px;\r\n}\r\n\r\n.resume-section21 ul {\r\n  list-style: none;\r\n\r\n  padding: 0;\r\n  /* margin: 0; */\r\n}\r\n\r\n\r\n\r\n/* .resume-section8 ul li span {\r\n  margin-left: 14px;\r\n} */\r\n\r\n \r\n.subheading21{\r\n  color: #542344;\r\n  margin-bottom: 2px;\r\n  font-size: 16px;\r\n  \r\n\r\n}\r\n/* .subheading9{\r\n  color: #542344;\r\n  /* margin-bottom: 0;\r\n  font-size: 12px; */\r\n  /* margin-bottom: 2px;\r\n  font-size: 16px;\r\n} */ */\r\n.p1 {\r\n  /* font-weight: bold; */\r\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n  font-size: 16px;\r\n  /* margin: 4px 0; */\r\n  text-align: justify;\r\n  text-wrap: wrap;\r\n  line-height: 22px; ;\r\n}\r\n/* .p11 {\r\n  font-weight: bold;\r\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n  font-size: 14px;\r\n  margin: 4px 0;\r\n\r\n} */\r\n\r\n.p11 {\r\n  font-weight: bold;\r\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n  font-size: 14px;\r\n  margin: 4px 0;\r\n  display: flex;\r\n}\r\n\r\n.title1{\r\n  text-wrap: nowrap;\r\n  color: #542344;\r\n}\r\n.span21 {\r\n  font-size: 16px;\r\n  font-weight: normal;\r\n  line-height: 20px;\r\n  color: #333333;\r\n  text-wrap: wrap;\r\n  text-align: justify;\r\n}\r\n\r\n.profile-image21 img {\r\n  width: 160px;\r\n  height: 160px;\r\n  border-radius: 50%;\r\n  border: 2px solid rgb(126, 155, 189);\r\n  margin: 10px auto;\r\n  justify-content: center !important;\r\n  align-items: center !important;\r\n  object-fit: cover;\r\n  display: block;\r\n\r\n}\r\n.experience-item8, .education-item8 {\r\n  position: relative;\r\n  padding-left: 28px;\r\n  border-left: 2px solid #0bb8f4;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.experience-item8::before, .education-item8::before {\r\n  content: \"\";\r\n  /* position: absolute;\r\n  top: 0; */\r\n  /* left: -4px; */\r\n  width: 6px;\r\n  height: 6px;\r\n  border-radius: 80%;\r\n  border: 2px solid #0bb8f4 ;\r\n}\r\n\r\n\r\n\r\n@media (max-width: 768px) {\r\n  .experience-item8, .education-item8 {\r\n    padding-left: 20px;\r\n    border-left-width: 1px;\r\n  }\r\n\r\n  .experience-item8::before, .education-item8::before {\r\n    width: 6px;\r\n    height: 6px;\r\n    left: -4px;\r\n  }\r\n}\r\n@media (max-width: 768px) {\r\n\r\n  .resume-left8 {\r\n    padding: 18px;\r\n\r\n  }\r\n\r\n  .resume-right21 {\r\n    padding: 18px;\r\n  }\r\n\r\n  .section-title-right21 {\r\n    font-size: 20px;\r\n  }\r\n  .section-title1 {\r\n    font-size: 20px;\r\n  }\r\n\r\n  .experience-item8 h3, .education-item8 h3 {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .experience-item8 h4, .education-item8 h4 {\r\n    font-size: 16px;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n\r\n\r\n  .resume-section21 {\r\n    margin-bottom: 18px;\r\n  }\r\n\r\n  .experience-item8, .education-item8 {\r\n    margin-bottom: 10px;\r\n  }\r\n\r\n  .experience-item8 h3, .education-item8 h3 {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .experience-item8 h4, .education-item8 h4 {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .resume-section21 ul li {\r\n    font-size: 14px;\r\n  }\r\n}\r\n\r\n\r\n/* .resume-section8.hr8 {\r\n  \r\n  border: 8px solid #542344;\r\n   margin-top: 20px ; \r\n} */\r\n\r\n.hr7 {\r\n  width: 80%;\r\n  margin-top: 4px;\r\n  margin-bottom: 10px;\r\n  border-top: 0.1rem solid  #542344;\r\n}\r\n.hr9 {\r\n  width: 100%;\r\n\r\n  margin-bottom: 8px;\r\n  border-top: 0.1rem solid  #542344;\r\n}\r\n\r\n.footer8 {\r\n  padding: 3px 0;\r\n  margin-top: 20px;\r\n  border-top: 1px solid #e9ecef;\r\n}\r\n\r\n.footer-text8 {\r\n  font-size: 16px;\r\n  color: #6c787d; \r\n  text-align: end;\r\n  margin-right: 18px;\r\n  margin-bottom: 2px;\r\n}\r\n\r\n.footer-link8 {\r\n  color: #007bff; \r\n  text-decoration: none;\r\n}\r\n\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
